// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"c9a55f3e","416":"391f0f5c","561":"7e3838ad","676":"885a315c","829":"f8853065","833":"f4f3ed8d","886":"f533d980"}[chunkId] + ".chunk.js";
};